<template>
    <div class="kgk-user-search">
        <div class="kgk-form-row">
            <div class="kgk-input-group">
                <div class="kgk-input-group-prepend">
                    <i v-if="loading" class="fas fa-spinner fa-spin fa-fw"></i>
                    <i v-else class="fas fa-search fa-fw"></i>
                </div>
                <input type="text" placeholder="Nach Username suchen ..." v-model="search">
            </div>
        </div>
        <table v-if="results && results.length > 0" style="width: 100%;">
            <tbody>
                <tr v-for="user in results" :key="user.identifier">
                    <td>
                        <div class="kgk-avatar kgk-avatar--list" v-kgk-avatar="user.avatar_url"></div>
                    </td>
                    <td>
                        <b v-if="user.selected">{{ user.username }}</b>
                        <span v-else>{{ user.username }}</span>
                    </td>
                    <td>{{ user.city }}</td>
                    <td class="text-right">
                        <button type="button" @click.prevent="user.selected = !user.selected">
                            <span v-if="user.selected"><i class="fas fa-check"></i> ausgewählt</span>
                            <span v-else>auswählen</span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <p v-if="search.length >= 3 && results.length == 0 && !loading">Keine Ergebnisse</p>
        <p v-else-if="search.length > 0 && search.length < 3">Bitte geben Sie mindestens 3 Zeichen ein.</p><!-- @TODO: min input length magic number -->
    </div>
</template>

<script>
    import axios from 'axios';
    import user from '../../api/user';

    export default {
        name: 'UserSearch',
        props: {
            excludeTeam: String
        },
        data() {
            return {
                loading: false,
                search: '',
                searchTimeout: null,
                searchRequest: null,
                searchCancel: null,
                searchDebounceTime: 400,
                results: [],
            }
        },
        computed: {
            selectedUsers: function() {
                return this.results.filter(user => user.selected);
            }
        },
        watch: {
            selectedUsers(newVal) {
                this.$emit('selected', newVal);
            },
            search() {
                if( this.timeout ) {
                    clearTimeout(this.searchTimeout);
                }
                this.searchTimeout = setTimeout(this.refresh, this.searchDebounceTime);

                if( this.search.length >= 3 ) { // @TODO: min input length magic number
                    this.loading = true;
                }
            }
        },
        methods: {
            refresh() {
                if( this.searchCancel ) { // not really needed
                    this.searchCancel.cancel();
                    this.loading = false;
                }
                //this.searchCancel.cancel('Outdated');

                if( this.search.length < 3 ) { // @TODO: min input length magic number
                    return;
                }

                this.searchCancel = axios.CancelToken.source();

                this.loading = true;

                user.search(
                    this,
                    this.search,
                    this.excludeTeam ?? null,
                    this.searchCancel.token,
                    (data) => {
                        console.log('finished');
                        this.loading = false;
                        this.results = data.users.map(function(user) {
                            user.selected = false;
                            return user;
                        });
                    },
                    (e) => {
                        if( axios.isCancel(e) ) {
                            return;
                        }

                        this.loading = false;
                    },
                    () => {
                        //if( !this.searchTimeout ) {

                        //}
                    },
                );
            },
        },
        mounted() {

        }
    }
</script>
